import path from '@/api/index'
import { axios } from '@/utils/request'
import parsePageParams from "../../utils/page";

export function getOrganize () {
    return axios({
        url: path.client + '/courseSelection/getOrganize',
        method: 'GET',
    })
}


export function getCourseTranslationById (id) {
    return axios({
        url: path.client + '/courseSelection/getCourseTranslationById/id/'+id,
        method: 'GET',
    })
}


// 分页
export function getCurriculumList(data) {
    return axios({
        url: path.client + '/courseSelection/getCurriculumList',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}
// 新增
export function addApply(data) {
    return axios({
        url: path.back + '/applymanagement/applyInfo/addApply',
        method: 'PUT',
        data: data
    })
}

export function getAgreement (id) {
    return axios({
        url: path.client + '/courseSelection/getAgreement/' + id,
        method: 'GET'
    })
}
// 新增
export function addUserGgreementRecord(data) {
    return axios({
        url: path.client + '/courseSelection/addUserGgreementRecord',
        method: 'POST',
        data: data
    })
}
